export default __webpack_public_path__ + "static/project-slide-4-992-765-89d5f09f5acca293fb2c0ac87c969fa0.webp";